export default "__VITE_ASSET__DpliEfPt__"